import Modal from "@Core/Components/Modals/Base/Modal";
import PrimaryButton from "@Core/Components/Buttons/PrimaryButton";
import InputLabel from "@Core/Components/InputLabel";
import TextInput from "@Core/Components/Inputs/TextInput";
import InputError from "@Core/Components/InputError";
type ConfirmOrChangeEmailModalProps = {
    open: boolean;
    email: string | null;
    onChange?: (email: string) => void;
    error?: string;
    emailRequired: boolean | null;
};

const ConfirmOrChangeEmailModal = ({
    open,
    email,
    onChange,
    error,
    emailRequired,
}: ConfirmOrChangeEmailModalProps) => {
    return (
        <Modal show={open} onClose={() => {}} maxWidth="xl" closeable={false}>
            <form className="py-5">
                <div className="flex flex-col items-center">
                    <h2 className="text-xl font-semibold">Email Required</h2>
                    {!emailRequired && (
                        <p className="text-sm text-gray-600 text-center">
                            We found the following email attached to this
                            account.
                            <br />
                            Would you like to use it or provide a different one
                            <br />
                            (this will be your Passport login moving forward)
                        </p>
                    )}

                    {emailRequired && (
                        <p className="text-sm text-gray-600 text-center">
                            Please enter your email address to continue.
                        </p>
                    )}
                    <div className="flex flex-col gap-2 mt-4">
                        <div>
                            <InputLabel htmlFor="email" value="Email" />

                            <TextInput
                                type="email"
                                id="email"
                                name="email"
                                value={email || ""}
                                onChange={(e) =>
                                    onChange && onChange(e.target.value)
                                }
                                className="mt-2"
                            />

                            <InputError message={error} className="mt-2" />
                        </div>
                        <PrimaryButton type="submit">Submit</PrimaryButton>
                    </div>
                </div>
            </form>
        </Modal>
    );
};

export default ConfirmOrChangeEmailModal;
